import api from "api";
import {RatingStarIcon, ThankYouCheckIcon} from "assets/icons";
import Modal from "components/Modal";
import ModalLayout from "components/ModalLayout";
import ProfileImage from "components/ProfileImage";
import {AwaitableModal} from "hooks/useAwaitableModal";
import {useState} from "react";

const Feedback: AwaitableModal<{}, {id: string; name: string; image?: string; isPowerTeam: boolean}> = ({
  open,
  resolve,
  onCancel,
  initialData,
}) => {
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState(5);
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const data = initialData || {};

  const onSubmit = () => {
    if (submitting) return;
    setSubmitting(true);
    api
      .leaveFeedback(data.id, feedback, rating)
      .then(() => setSent(true))
      .finally(() => setSubmitting(false));
  };

  if (sent) {
    return (
      <Modal open={open} close={resolve}>
        <ModalLayout
          title="Feedback Saved"
          footer={
            <button onClick={resolve} className="btn-primary ml-auto">
              Continue
            </button>
          }
        >
          <div className="flex flex-col items-center gap-3 py-4">
            <ThankYouCheckIcon />
            <span className="text-sm text-brand-muted text-center">Thank you for using our service</span>
          </div>
        </ModalLayout>
      </Modal>
    );
  }

  return (
    <Modal open={open} close={!submitting ? onCancel : () => {}}>
      <ModalLayout
        title="Leave Feedback"
        scrollable
        footer={
          <>
            <button className="btn-secondary" disabled={submitting} onClick={onCancel}>
              Cancel
            </button>
            <button className="btn-primary" disabled={submitting} onClick={onSubmit}>
              Leave Feedback
            </button>
          </>
        }
      >
        <div className="flex flex-col items-center gap-3">
          <ProfileImage src={data.image} size={80} />
          <div className="flex flex-col items-center text-center gap-0.5">
            <span className="text-xs text-brand-muted">Feedback For</span>
            <span className="text-base font-semibold text-brand-navy">{data.name}</span>
          </div>
        </div>
        <div className="flex items-center relative max-w-max self-center">
          <input
            type="range"
            className="opacity-0 absolute inset-0 cursor-pointer"
            min={0}
            max={5}
            step={1}
            onChange={(e) => setRating(e.currentTarget.valueAsNumber)}
          />
          {Array(5)
            .fill(null)
            .map((_, i) => (
              <RatingStarIcon className={rating >= i + 1 ? undefined : "fill-slate-100"} key={i} />
            ))}
        </div>
        <textarea
          placeholder="Describe your experience"
          rows={4}
          className="w-full"
          value={feedback}
          onChange={(e) => setFeedback(e.currentTarget.value)}
        />
      </ModalLayout>
    </Modal>
  );
};

export default Feedback;
